// Generated by purs version 0.12.3
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Prelude = require("../Prelude/index.js");
var React_Basic_DOM_Events = require("../React.Basic.DOM.Events/index.js");
var React_Basic_Events = require("../React.Basic.Events/index.js");
var React_Basic_Hooks = require("../React.Basic.Hooks/index.js");
var Type_Equality = require("../Type.Equality/index.js");
var useInput = function (initialValue) {
    return React_Basic_Hooks.bind(React_Basic_Hooks.ixBindRender)(React_Basic_Hooks.useState(initialValue))(function (v) {
        return Control_Applicative.pure(React_Basic_Hooks.applicativeRender(Type_Equality.refl))({
            onChange: React_Basic_Events.handler(React_Basic_DOM_Events.targetValue)(function (v1) {
                return v.value1(function (v2) {
                    return Data_Maybe.fromMaybe("")(v1);
                });
            }),
            value: v.value0
        });
    });
};
module.exports = {
    useInput: useInput
};
